export default "__VITE_ASSET__BEMq_DHK__"